import { Injectable } from '@angular/core';
import { ToastrService } from 'ngx-toastr';
import { ResultType } from '../models/enums/result-type.enum';

@Injectable({
    providedIn: 'root',
})
export class CustomToastService {
    constructor(private toastrService: ToastrService) {}

    // Generic toast
    genericToast(type: ResultType, title?: string) {
        switch (type) {
            case ResultType.Success:
                this.successToast('Successfull done.', title);
                break;
            case ResultType.Error:
                this.errorToast('Sorry, looks like there are some errors detected, please try again.', title);
                break;
            case ResultType.Warning:
                this.warningToast('Warning!', title);
                break;
        }
    }

    // success toast
    successToast(message: string, title?: string) {
        let successToastRef = this.toastrService.show(message, title);
        successToastRef.toastRef.componentInstance.case = 'success';
    }

    // error toast
    errorToast(message: string, title?: string) {
        let errorToastRef = this.toastrService.show(message, title);
        errorToastRef.toastRef.componentInstance.case = 'error';
    }

    // error toast
    warningToast(message: string, title?: string) {
        let warningToastRef = this.toastrService.show(message, title);
        warningToastRef.toastRef.componentInstance.case = 'warning';
    }

    // info toast
    infoToast(message: string, title?: string) {
        let infoToastRef = this.toastrService.show(message, title);
        infoToastRef.toastRef.componentInstance.case = 'info';
    }
}
